export type FactSheetLinkKind =
  "condition" | "medication" | "procedure" | "supplement" | "test" | "therapy";

export type FactSheetLinkTarget = {
  kind: FactSheetLinkKind;
  id: string;
};

export type FactSheetLinkTerm = {
  terms: string[];
  target: FactSheetLinkTarget;
};

export const FACT_SHEET_LINK_TERMS: FactSheetLinkTerm[] = [
  {
    terms: ["chronic endometritis"],
    target: { kind: "condition", id: "dx-chronic-endometritis" },
  },
  {
    terms: ["endometriosis"],
    target: { kind: "condition", id: "dx-endometriosis" },
  },
  {
    terms: ["adenomyosis"],
    target: { kind: "condition", id: "dx-adenomyosis" },
  },
  {
    terms: ["PMOS", "PCOS", "PMOS (ex PCOS)"],
    target: { kind: "condition", id: "dx-pcos" },
  },
  {
    terms: ["hypothyroidism", "subclinical hypothyroidism"],
    target: { kind: "condition", id: "dx-hypothyroidism" },
  },
  {
    terms: ["hyperprolactinemia"],
    target: { kind: "condition", id: "dx-hyperprolactinemia" },
  },
  {
    terms: ["recurrent pregnancy loss", "RPL"],
    target: { kind: "condition", id: "dx-recurrent-pregnancy-loss" },
  },
  {
    terms: ["antiphospholipid syndrome", "APS"],
    target: { kind: "condition", id: "dx-antiphospholipid-syndrome" },
  },
  {
    terms: ["thin endometrium", "thin lining"],
    target: { kind: "condition", id: "dx-thin-endometrium" },
  },
  {
    terms: ["uterine anomalies", "mullerian anomalies"],
    target: { kind: "condition", id: "dx-mullerian-anomalies" },
  },
  {
    terms: ["fibroids", "uterine fibroids"],
    target: { kind: "condition", id: "dx-uterine-fibroids" },
  },
  {
    terms: ["polyps", "uterine polyps"],
    target: { kind: "condition", id: "dx-uterine-polyps" },
  },
  {
    terms: ["tubal factor infertility", "tubal factor"],
    target: { kind: "condition", id: "dx-tubal-factor" },
  },
  {
    terms: ["varicocele"],
    target: { kind: "condition", id: "dx-varicocele" },
  },
  {
    terms: ["azoospermia"],
    target: { kind: "condition", id: "dx-azoospermia" },
  },
  {
    terms: ["cervical stenosis"],
    target: { kind: "condition", id: "dx-cervical-stenosis" },
  },
  {
    terms: ["luteal phase defect"],
    target: { kind: "condition", id: "dx-luteal-phase-defect" },
  },
  {
    terms: ["diminished ovarian reserve", "DOR"],
    target: { kind: "condition", id: "dx-diminished-ovarian-reserve" },
  },
  {
    terms: ["premature ovarian insufficiency", "POI"],
    target: { kind: "condition", id: "dx-premature-ovarian-insufficiency" },
  },
  {
    terms: ["letrozole", "Femara"],
    target: { kind: "medication", id: "med-letrozole" },
  },
  {
    terms: ["clomiphene citrate", "clomiphene", "Clomid"],
    target: { kind: "medication", id: "med-clomiphene" },
  },
  {
    terms: ["metformin"],
    target: { kind: "medication", id: "med-metformin" },
  },
  {
    terms: ["cabergoline", "Dostinex"],
    target: { kind: "medication", id: "med-cabergoline" },
  },
  {
    terms: ["bromocriptine"],
    target: { kind: "medication", id: "med-bromocriptine" },
  },
  {
    terms: ["levothyroxine", "Synthroid"],
    target: { kind: "medication", id: "med-levothyroxine" },
  },
  {
    terms: ["low-dose aspirin", "baby aspirin"],
    target: { kind: "medication", id: "med-low-dose-aspirin" },
  },
  {
    terms: ["enoxaparin", "Lovenox"],
    target: { kind: "medication", id: "med-enoxaparin" },
  },
  {
    terms: ["doxycycline"],
    target: { kind: "medication", id: "med-doxycycline" },
  },
  {
    terms: ["sildenafil", "Viagra"],
    target: { kind: "medication", id: "med-sildenafil" },
  },
  {
    terms: ["dexamethasone"],
    target: { kind: "medication", id: "med-dexamethasone" },
  },
  {
    terms: ["estradiol", "Estrace"],
    target: { kind: "medication", id: "med-estradiol-oral" },
  },
  {
    terms: ["leuprolide", "Lupron"],
    target: { kind: "medication", id: "med-leuprolide" },
  },
  {
    terms: ["ganirelix"],
    target: { kind: "medication", id: "med-ganirelix" },
  },
  {
    terms: ["cetrorelix", "Cetrotide"],
    target: { kind: "medication", id: "med-cetrorelix" },
  },
  {
    terms: ["ALICE"],
    target: {
      kind: "test",
      id: "test-chronic-endometritis-testing-products-alice",
    },
  },
  {
    terms: [
      "chronic endometritis testing",
      "chronic endometritis test",
      "chronic endometritis tests",
    ],
    target: { kind: "test", id: "test-chronic-endometritis-testing" },
  },
  {
    terms: ["EMMA"],
    target: {
      kind: "test",
      id: "test-endometrial-microbiome-testing-products-emma",
    },
  },
  {
    terms: ["ERBiome"],
    target: {
      kind: "test",
      id: "test-endometrial-microbiome-testing-products-erbiome",
    },
  },
  {
    terms: [
      "endometrial microbiome testing",
      "endometrial microbiome test",
      "endometrial microbiome tests",
      "microbiome testing",
      "microbiome test",
      "microbiome tests",
    ],
    target: { kind: "test", id: "test-endometrial-microbiome-testing" },
  },
  {
    terms: ["ERA"],
    target: {
      kind: "test",
      id: "test-endometrial-receptivity-testing-products-era",
    },
  },
  {
    terms: ["ERPeak"],
    target: {
      kind: "test",
      id: "test-endometrial-receptivity-testing-products-erpeak",
    },
  },
  {
    terms: ["beREADY"],
    target: {
      kind: "test",
      id: "test-endometrial-receptivity-testing-products-beready",
    },
  },
  {
    terms: [
      "endometrial receptivity testing",
      "endometrial receptivity test",
      "endometrial receptivity tests",
      "receptivity testing",
      "receptivity test",
      "receptivity tests",
    ],
    target: { kind: "test", id: "test-endometrial-receptivity-testing" },
  },
  {
    terms: ["EndomeTRIO"],
    target: {
      kind: "test",
      id: "test-endometrial-add-on-bundle-products-endometrio",
    },
  },
  {
    terms: ["ER-Complete"],
    target: {
      kind: "test",
      id: "test-endometrial-add-on-bundle-products-er-complete",
    },
  },
  {
    terms: [
      "endometrial add-on bundle",
      "endometrial add-on bundles",
      "endometrial add-on test",
      "endometrial add-on tests",
    ],
    target: { kind: "test", id: "test-endometrial-add-on-bundle" },
  },
  {
    terms: ["semen analysis"],
    target: { kind: "test", id: "test-semen-analysis" },
  },
  {
    terms: ["sperm DNA fragmentation"],
    target: { kind: "test", id: "test-semen-analysis" },
  },
  {
    terms: ["karyotype"],
    target: { kind: "test", id: "test-karyotype" },
  },
  {
    terms: ["PGT-A"],
    target: { kind: "test", id: "test-pgt-a" },
  },
  {
    terms: [
      "preimplantation genetic testing",
      "preimplantation genetic test",
      "preimplantation genetic tests",
      "PGT",
      "experimental embryo selection",
      "experimental embryo selection tests",
      "non-invasive PGT-A",
      "mitochondrial DNA load",
    ],
    target: { kind: "test", id: "test-preimplantation-genetic-testing" },
  },
  {
    terms: ["PGT-M"],
    target: { kind: "test", id: "test-pgt-m" },
  },
  {
    terms: ["PGT-SR"],
    target: { kind: "test", id: "test-pgt-sr" },
  },
  {
    terms: [
      "PGT-P",
      "polygenic embryo screening",
      "polygenic embryo selection",
      "polygenic risk scoring",
      "polygenic risk score",
    ],
    target: { kind: "test", id: "test-pgt-p" },
  },
  {
    terms: ["AMH blood test", "AMH"],
    target: { kind: "test", id: "test-amh" },
  },
  {
    terms: ["antral follicle count", "AFC"],
    target: { kind: "test", id: "test-afc" },
  },
  {
    terms: ["prolactin"],
    target: { kind: "test", id: "test-prolactin" },
  },
  {
    terms: ["thyroid panel"],
    target: { kind: "test", id: "test-thyroid-panel" },
  },
  {
    terms: ["saline sonogram", "SIS"],
    target: { kind: "test", id: "test-saline-sonogram" },
  },
  {
    terms: ["HSG", "hysterosalpingogram"],
    target: { kind: "procedure", id: "procedure-hsg" },
  },
  {
    terms: ["hysteroscopy"],
    target: { kind: "procedure", id: "proc-hysteroscopy" },
  },
  {
    terms: ["laparoscopy"],
    target: { kind: "procedure", id: "proc-laparoscopy" },
  },
  {
    terms: ["endometrial biopsy"],
    target: { kind: "procedure", id: "proc-endometrial-biopsy" },
  },
  {
    terms: ["embryo transfer"],
    target: { kind: "procedure", id: "proc-embryo-transfer" },
  },
  {
    terms: ["frozen embryo transfer", "FET"],
    target: { kind: "procedure", id: "proc-frozen-embryo-transfer" },
  },
  {
    terms: ["egg retrieval"],
    target: { kind: "procedure", id: "proc-egg-retrieval" },
  },
  {
    terms: ["ovarian stimulation"],
    target: { kind: "procedure", id: "proc-ovarian-stimulation" },
  },
  {
    terms: ["TESE", "micro-TESE", "testicular sperm extraction"],
    target: { kind: "procedure", id: "proc-tese" },
  },
  {
    terms: ["CoQ10"],
    target: { kind: "supplement", id: "supplement-coq10" },
  },
  {
    terms: ["vitamin D"],
    target: { kind: "supplement", id: "supplement-vitamin-d" },
  },
  {
    terms: ["DHEA"],
    target: { kind: "supplement", id: "supplement-dhea" },
  },
  {
    terms: ["myo-inositol", "inositol"],
    target: { kind: "supplement", id: "supplement-myo-inositol" },
  },
  {
    terms: ["NAC", "N-acetylcysteine"],
    target: { kind: "supplement", id: "supplement-nac" },
  },
  {
    terms: ["omega-3", "EPA", "DHA"],
    target: { kind: "supplement", id: "supplement-omega-3" },
  },
  {
    terms: ["selenium"],
    target: { kind: "supplement", id: "supplement-selenium" },
  },
  {
    terms: ["zinc"],
    target: { kind: "supplement", id: "supplement-zinc" },
  },
  {
    terms: ["vitamin E"],
    target: { kind: "supplement", id: "supplement-vitamin-e" },
  },
  {
    terms: ["curcumin"],
    target: { kind: "supplement", id: "supplement-curcumin" },
  },
  {
    terms: ["berberine"],
    target: { kind: "supplement", id: "supplement-berberine" },
  },
  {
    terms: ["melatonin"],
    target: { kind: "supplement", id: "supplement-melatonin" },
  },
  {
    terms: ["probiotics"],
    target: { kind: "supplement", id: "supplement-probiotics" },
  },
];
